import React from 'react'
import PropTypes from 'prop-types'
import './Field.scss'

const FieldInput = ({
  isCalendar,
  handleClick,
  placeholder,
  value,
  disabled,
  handleType,
  handleOnKeyDown,
  buttonClass,
  buttonClassList,
  iconClass,
  handleOnFocus,
  handleOnBlur,
}) => {
  return (
    <div
      className={isCalendar ? buttonClass : buttonClassList}
      onClick={!isCalendar ? handleClick : null}
    >
      <input
        tabIndex="0"
        type="text"
        className={`Field__input ${isCalendar ? 'Field__calendar' : ''}`}
        placeholder={placeholder}
        value={value || ''}
        disabled={disabled}
        onChange={handleType}
        onKeyDown={handleOnKeyDown}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
      />
      {isCalendar && <span className={iconClass} onClick={handleClick} />}
    </div>
  )
}

FieldInput.propTypes = {
  placeholder: PropTypes.string,
  isCalendar: PropTypes.bool,
  handleClick: PropTypes.func,
  handleOnKeyDown: PropTypes.func,
  handleOnFocus: PropTypes.func,
  handleOnBlur: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  handleType: PropTypes.func,
  buttonClass: PropTypes.string,
  buttonClassList: PropTypes.string,
  iconClass: PropTypes.string,
}

export default FieldInput
